import { RestClientBuilder } from '@teqplay/api'

import { TRestContext } from './builder'
import { createRestConfig } from './config'
import vesselJourney from './resources/vesselJourney'
import ship from './resources/ship'
import notification from './resources/notification'
import user from './resources/user'
import feedback from './resources/feedback'
import portInfrastructure from './resources/portInfrastructure'
import vesselNotes from './resources/vesselNotes'
import sof from './resources/sof'
import lineup from './resources/lineup'

const resources = {
  vesselJourney,
  ship,
  notification,
  user,
  feedback,
  portInfrastructure,
  vesselNotes,
  sof,
  lineup
}

/**
 * Register resources and build the RestServer initializer
 */
const restServerInitializer = new RestClientBuilder<TRestContext>().build(resources)

/**
 * Type for the API client returned by createApi
 */
export type ApiClient = ReturnType<typeof restServerInitializer>

/**
 * Create Server API that works for both logged-in and anonymous users.
 * If session is provided and has access token, includes it in Authorization header.
 *
 * @param session - Optional Auth0 session data
 * @returns The configured API client
 */
export function createApi(accessToken?: string): ApiClient {
  const clientConfig = createRestConfig(accessToken)
  return restServerInitializer({
    ctx: { appName: 'portcallone' },
    config: clientConfig
  })
}
